import { Component, OnInit, AfterViewInit, ElementRef, OnDestroy, inject } from '@angular/core';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';

// primeng
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';

// services
import { ToasterService } from '@ui-nuvertos/auth';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterModule, ToastModule, ButtonModule],
  templateUrl: './app.html',
})

export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  private routerSubscription?: Subscription;
  private toasterService = inject(ToasterService);
  private el = inject(ElementRef);
  private router = inject(Router);

  ngOnInit() {
    // Set up width monitoring
    this.updateWidthDisplay();
    
    // Listen for route changes to apply auth-page class
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.handleRouteChange(event.url);
      });
  }

  ngAfterViewInit() {
    // Monitor for layout changes
    this.setupWidthMonitoring();
  }

  private updateWidthDisplay() {
    const widthDisplay = document.getElementById('width-display');
    if (widthDisplay) {
      const contentWidth = this.el.nativeElement.querySelector('.demo-content')?.offsetWidth || 0;
      widthDisplay.textContent = `${contentWidth}px`;
    }
  }

  private setupWidthMonitoring() {
    // Use ResizeObserver to monitor width changes
    if (window.ResizeObserver) {
      const resizeObserver = new ResizeObserver(() => {
        this.updateWidthDisplay();
      });
      
      const contentElement = this.el.nativeElement.querySelector('.demo-content');
      if (contentElement) {
        resizeObserver.observe(contentElement);
      }
    } else {
      // Fallback for browsers without ResizeObserver
      window.addEventListener('resize', () => {
        this.updateWidthDisplay();
      });
    }
  }

  onApiError() {
    this.toasterService.error('Login failed', 'Invalid credentials');
  }

  onApiSuccess() {
    this.toasterService.success('Login successful', 'Welcome!');
  }

  private handleRouteChange(url: string): void {
    const isAuthPage = url.includes('/login') || url.includes('/unauthorized');
    
    if (isAuthPage) {
      document.body.classList.add('auth-page');
    } else {
      document.body.classList.remove('auth-page');
    }
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

}